<template>
  <div id="image-upload-step">
    <step-template>
      <div slot="back" @click="back">&larr;</div>
      <div slot="default">
        <div
          class="mb-4 md:mb-6"
        >Now, upload an image (not a selfie!) that best reflects your experience of nature or society in your local area.</div>
        <img class="block mb-4" src="../assets/img/examples.png" />
        <div
          class="text-sm mb-4 md:mb-6 opacity-50"
        >Please make sure you have taken this picture yourself or have permission to upload&nbsp;it.</div>
        <input
          type="file"
          id="input"
          ref="fileinput"
          class="mb-6 md:mb-8 text-grey w-5/6"
          @change="fileInputChanged"
        />
        <div class="flex">
          <csf-button
            type="primary"
            :disabled="!fileHasBeenSelected || !fileExtension || isUploading || fileTooLarge"
            @click="next"
            class="mr-4 self-start"
          >Upload</csf-button>
          <transition name="pop">
            <div
              v-if="noFileError"
              class="text-sm md:text-base flex items-center"
            >Please select an image to upload.</div>
            <div
              v-else-if="fileHasBeenSelected && !fileExtension"
              class="text-sm md:text-base flex items-center"
            >The image needs to be in JPEG or PNG format to upload.</div>
            <div
              v-else-if="fileHasBeenSelected && fileExtension && fileTooLarge"
              class="text-sm md:text-base flex items-center"
            >The image needs to be under 5 Mb.</div>
          </transition>
        </div>
      </div>
    </step-template>
  </div>
</template>

<script>
import CsfButton from "../components/csf-button.vue";
import StepTemplate from "./step-template.vue";
import { firebaseApp, firestore } from "../js/main.js";

export default {
  components: { CsfButton, StepTemplate },
  data() {
    return {
      noFileError: false,
      wrongFormatError: false,
      fileHasBeenSelected: false,
      fileExtension: false,
      isUploading: false,
      fileSize: null,
      fileTooLarge: false
    };
  },
  computed: {
    fileToUpload() {
      return this.$refs.fileinput;
    },
    currentYear() {
      return this.$route.params.year;
    }
  },
  methods: {
    fileInputChanged() {
      if (this.fileToUpload.files.length) this.fileHasBeenSelected = true;
      else this.fileHasBeenSelected = false;
      this.setFileExtension();
      this.setFileSize();
      this.validate();
    },
    setFileExtension() {
      if (!this.fileHasBeenSelected) this.fileExtension = null;
      if (this.fileToUpload.files[0].type == "image/png")
        this.fileExtension = "png";
      else if (this.fileToUpload.files[0].type == "image/jpeg")
        this.fileExtension = "jpg";
      else this.fileExtension = null;
    },
    setFileSize() {
      if (!this.fileHasBeenSelected) this.fileSize = null;
      else {
        this.fileSize = this.fileToUpload.files[0].size;
      }
    },
    back() {
      this.$store.commit("transition", { action: "BACK" });
    },
    validate() {
      this.noFileError = false;
      this.wrongFormatError = false;
      this.fileTooLarge = false;
      if (!this.fileHasBeenSelected) this.noFileError = true;
      else if (!this.fileExtension) this.wrongFormatError = true;
      else if (this.fileSize > 5000000) this.fileTooLarge = true;
      return (
        !this.noFileError &&
        !this.wrongFormatError & !this.isUploading & !this.fileTooLarge
      );
    },
    next() {
      if (this.validate()) this.upload();
    },
    upload() {
      // Firebase refs
      var storageRef = firebaseApp.storage().ref();
      var pinRef = firestore.collection("pins").doc(this.$store.state.anonUID);

      this.isUploading = true;

      pinRef
        .set({
          latlng: this.$store.state.newPoint,
          group: this.currentYear,
          time: Date.now()
        })
        .then(() => {
          const newImageRef = storageRef.child(
            `${this.$store.state.anonUID}.${this.fileExtension}`
          );
          newImageRef.put(this.fileToUpload.files[0]).then(snapshot => {
            console.log("Uploaded image successfully.");
            console.log(snapshot);
            pinRef
              .update({
                imageUrl: snapshot.downloadURL
              })
              .then(snapshot => {
                console.log("Updated the pin");
                this.$store.commit("transition", { action: "UPLOAD_SUCCESS" });
              })
              .catch(() => {
                this.isUploading = false;
              });
          });
        })
        .catch(() => {
          this.isUploading = false;
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// ImageUploadStep.vue?1c3a802e